import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class AutologService {

  private VISIOTEX_BASE_URL = environment.visiotexBaseURL;

  constructor(private httpClient: HttpClient) {
  }

  login(dossierNumber: string, token: string): Observable<any> {
    return this.httpClient.get<any>(this.VISIOTEX_BASE_URL + '/info/DossierService.svc/ConnexionLienTransparent' +
      '?ref=' + dossierNumber +
      '&c=' + token)
      .map(response => response.Response);
  }

}



// WEBPACK FOOTER //
// ./src/app/autolog/autolog.service.ts